import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_action_RowClass } from "../../../dbschema";

export class BotCfActionContainerModel extends BaseContainerModel{
  alg_bot_cf_action: alg_bot_cf_action_RowClass = new alg_bot_cf_action_RowClass();
}
